import { Pipe, PipeTransform } from '@angular/core';
import { DatabaseType } from '@core/state/environment/environment.state';

/**
 * Transforms a database name + type into a user-friendly display name.
 *
 * Uses the server-derived databaseType for unambiguous identification rather than
 * guessing from the database name alone. This correctly handles cases like a local
 * copy of "syrftest" (which is development, not production).
 *
 * @example
 * {{ 'syrftest' | databaseDisplayName:'production' }}    // "Production Database"
 * {{ 'syrftest' | databaseDisplayName:'development' }}   // "syrftest"
 * {{ 'syrf_staging' | databaseDisplayName:'staging' }}   // "Staging Database"
 * {{ 'syrf_pr_123' | databaseDisplayName:'preview' }}    // "Preview Database"
 */
@Pipe({
  name: 'databaseDisplayName',
  standalone: true,
})
export class DatabaseDisplayNamePipe implements PipeTransform {
  transform(value: string | null | undefined, databaseType?: DatabaseType | null): string {
    if (!value) {
      return '';
    }

    // When databaseType is provided, use it for unambiguous display names
    if (databaseType) {
      switch (databaseType) {
        case 'production':
          return 'Production Database';
        case 'staging':
          return 'Staging Database';
        case 'preview':
          return 'Preview Database';
        default:
          return value;
      }
    }

    // Legacy fallback: when databaseType is not available (e.g. API not yet updated)
    if (value.toLowerCase() === 'syrftest') {
      return 'Production Database';
    }

    return value;
  }
}
